import React from 'react'
import { Skeleton } from '@mui/material'

/**
 * Skeleton placeholder for a value/text that will resolve once data loads.
 * Mirrors the inline Skeleton pattern used for balances (cf. Slide_Balance).
 *
 * props:
 *  - width    (str/number)  width of the skeleton (default "8em")
 *  - height   (str/number)  height of the skeleton
 *  - black    (boolean)     use a dark overlay (for light backgrounds)
 *  - variant  (string)      MUI Skeleton variant (default "text")
 */
export default function SkeletonText(props) {
	const bgcolor = props.black ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.12)"
	return (
		<Skeleton
			variant={props.variant || "text"}
			width={props.width || "8em"}
			height={props.height}
			sx={{
				display: "inline-block",
				bgcolor: bgcolor,
			}}
		/>
	)
}
